import type { RepositoryError, RepositoryResult } from '../types/database.types'

export function repositoryError(error: unknown): RepositoryError {
  if (typeof error === 'object' && error !== null && 'message' in error) {
    const message = String(error.message)
    const code = 'code' in error && error.code ? String(error.code) : undefined
    return { message, code }
  }

  return { message: 'Unexpected database error.' }
}

export function success<T>(data: T): RepositoryResult<T> {
  return { data, error: null }
}

export function failure<T = never>(error: unknown): RepositoryResult<T> {
  return { data: null, error: repositoryError(error) }
}
